const RequestStatusEnum = {
	pending: {
		label: "در انتظار",
		value: 0,
	},
	success: {
		label: "موفق",
		value: 1,
	},
	assigned: {
		label: "تخصیص داده‌شده",
		value: 2,
	},
	rejected: {
		label: "ناموفق",
		value: 3,
	},
};

export default RequestStatusEnum;
